<div class="modals return" [class.start-print]="startPrint" [class.modals-show]="isModalReturnsShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="return-modal-body" *ngIf="returnSelected">
    <h3 class="modal-return-head">Заявка на повернення до замовлення №{{ returnSelected.order_id }}</h3>
    <table class='order-data'>
      <thead>
      <tr>
        <th>Бренд</th>
        <th>Найменування</th>
        <th>Фасовка</th>
        <th>Артикул</th>
        <th>Ціна</th>
        <th>Кіл-ть</th>
        <th>Сума</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let goods of returnGoods">
        <td>{{ goods.brand_name }}</td>
        <td>{{ goods.good_name }}</td>
        <td>{{ goods.name }}</td>
        <td>{{ goods.artikul}}</td>
        <td>{{ goods.price }}</td>
        <td>{{ goods.count }}</td>
        <td>{{ goods.summa }}</td>
      </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="column"></div>
      <div class="column shrink">
        <a (click)="printReturn()" class="button small">Роздрукувати</a>
      </div>
    </div>
  </div>
</div>

<div class="print-return" *ngIf="printReturns">
  <h3 class="modal-return-head">Заявка на повернення Від {{ returnSelected.date }}</h3>
  <div>Сума повернення: {{ returnSelected.sum_fixed }} УЕ</div>
  <div style="padding-bottom: 10px">Коментар: {{ returnSelected.comment }}</div>
  <table class='order-data'>
    <thead>
    <tr>
      <th>Бренд</th>
      <th>Найменування</th>
      <th>Фасовка</th>
      <th>Артикул</th>
      <th>Ціна</th>
      <th>Кіл-ть</th>
      <th>Сума</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let goods of returnGoods">
      <td>{{ goods.brand_name }}</td>
      <td>{{ goods.good_name }}</td>
      <td>{{ goods.name }}</td>
      <td>{{ goods.artikul }}</td>
      <td>{{ goods.price }}</td>
      <td>{{ goods.count }}</td>
      <td>{{ goods.summa }}</td>
    </tr>
    </tbody>
  </table>
</div>

<div class="dark-layer"
     [class.start-print]="startPrint"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
